import { IconProps } from "./";
import Icon from "./assets/copy_paste_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24CopyPaste(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
